import * as Register from './register';
import * as Info from './info';
import * as Login from './login';


export {
    Info,
    Login,
    Register,
};
